const momentDate = (date, dateRange) => {
    if (!date || !dateRange) return null;
    const moment = require('moment');
    const selectedDate = moment(date);
    switch (dateRange) {
        case 'today':
            return selectedDate.clone().format('YYYY-MM-DD');
        case '1week':
            return selectedDate.clone().subtract(1, 'weeks').format('YYYY-MM-DD');
        case '15days':
            return selectedDate.clone().subtract(15, 'days').format('YYYY-MM-DD');
        case '1month':
            return selectedDate.clone().subtract(1, 'months').format('YYYY-MM-DD');
        case '3months':
            return selectedDate.clone().subtract(3, 'months').format('YYYY-MM-DD');
        default:
            return null;
    }
};
export default momentDate;
